module.exports = __webpack_public_path__ + "img/hyakunin_issyu.ded84db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hyakunin_issyu.png
// module id = P8Oq
// module chunks = 1